import React from 'react';
import { useMediaQuery } from 'hooks';
import { Desktop } from './Desktop';
import { Mobile } from './Mobile';

export const Footer = () => {
  const isDesktopOrLaptop = useMediaQuery(1023);
  return <footer>{isDesktopOrLaptop ? <Desktop /> : <Mobile />}</footer>;
};
